import React from "react";
import Isvg from "../../../../vendor/react-inlinesvg";
import { VstButton } from "vstui";

class ReviewFlashcard extends React.Component {
  componentDidMount() {
    this.props.focusCardHolder();
  }

  render() {
    return (
      <div id="main-window">
        <div id="flashcard-controls">
          <div id="card-holder">
            <div className="flashcard front visible">
              <div className="card-content" id="content-summary">
                <VstButton
                  onClick={this.props.repeat}
                  className="naked noButton summary-option"
                >
                  <Isvg
                    className="summary-icon"
                    src="/img/card-icon-repeat.svg"
                  />
                  {i18n.t("flashcards.summary-repeat")}
                  <span className="hintText">
                    {i18n.t("flashcards.summary-repeat")}
                  </span>
                </VstButton>
                <VstButton
                  onClick={this.props.shuffleDeck}
                  className="naked noButton summary-option"
                >
                  <Isvg
                    className="summary-icon"
                    src="/img/card-icon-shuffle.svg"
                  />
                  {i18n.t("flashcards.summary-shuffle")}
                  <span className="hintText">
                    {i18n.t("flashcards.summary-shuffle")}
                  </span>
                </VstButton>
                <VstButton
                  onClick={this.props.restartDeck}
                  className="naked noButton summary-option"
                >
                  <Isvg
                    className="summary-icon"
                    src="/img/card-icon-reset.svg"
                  />
                  {i18n.t("flashcards.summary-reset")}
                  <span className="hintText">
                    {i18n.t("flashcards.summary-reset")}
                  </span>
                </VstButton>
                <VstButton
                  id="done-button"
                  onClick={this.props.viewReviewSlide}
                >
                  {i18n.t("base.done")}
                </VstButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReviewFlashcard;
